import { Styles } from 'shared/types';

export const SatisfactionTooltip: Styles = {
  '& .MuiTooltip-tooltip': {
    maxWidth: 210,
  },
};
